export default __webpack_public_path__ + "static/media/rinie1.06d85b8e.bin";